
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4556_18669)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M-.11 5.265c0-1.146.948-2.076 2.116-2.076h10.77c1.168 0 2.115.93 2.115 2.076v7.549c0 1.146-.947 2.075-2.116 2.075H2.006c-1.168 0-2.115-.929-2.115-2.075V5.265zm1.667.032a.584.584 0 00-.8.157.56.56 0 00.16.786l5.3 3.467a2.15 2.15 0 002.347 0l5.3-3.467a.56.56 0 00.16-.786.584.584 0 00-.8-.157l-5.3 3.468a.977.977 0 01-1.067 0l-5.3-3.468z","fill":"#C7CBCF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4556_18669"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h15v18H0z"}})])])])
          )
        }
      }
    